import './MyPage.css'
import React, { Component } from 'react';
import PracticeListRoot from './PracticeListRoot'
import DisplayNumber from './containers/DisplayNumber'
import { Link, Route, Switch, BrowserRouter as Router } from "react-router-dom"
import { Layout, Divider,Menu, Breadcrumb, Col, Row, Image, Upload } from 'antd';
import { Button, Badge, Avatar, Progress, Spin, Table, Tag, Space, Tooltip } from 'antd';
import { Typography } from 'antd';
import {store} from './store'
import axios from 'axios'
import { resolveFileUrl } from './utils/resolveFileUrl'

const { Title } = Typography;
const { Header, Content, Footer } = Layout;


export default class MyPage extends Component{

  state = {
    records:[],
    record_rows:[],
    session: {},
    domains: [
      ['BS', '기초생명의학 지식', '#13c2c2'],
      ['CD', '임상적 의사결정 능력', '#f5222d'],
      ['CSIA', '개별 동물에서의 건강과 질병 관리를 위한 임상 기술', '#5468ff'],
      ['MAH', '군집동물의 건강과 질병 관리', '#52c41a'],
      ['OHPH', '원헬스와 공중보건 전문성', '#722ed1'],
      ['SC', '학문과 연구', '#faad14'],
      ['VP', '수의전문직업성', '#a0d911'],
      ['CAC', '소통과 협력', '#37e4e4'],
    ],
    domain_count: {
      'BS':0,
      'CD':0,
      'CSIA':0,
      'MAH':0,
      'OHPH':0,
      'SC':0,
      'VP':0,
      'CAC':0,
    },
    profile_image:'',
    loading: true,
  }

  componentDidMount() {
    axios('/record/my', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
    }).then( res => {
      let data = res.data
      this.setState({
        ...this.state,
        records: data.records,
        username: data.username,
        student_number: data.student_number,
        phone: data.phone,
        managing_professor: data.managing_professor,
        etc: data.etc,
        profile_image: data.profile_image,
        loading: false,
      })
    });

    axios('/record/list', {
      method: "POST",
      headers: {
          "Content-Type": "application/json; charset=utf-8"
      },
    }).then( res => {
      let records = res.data.records
      for (let i=0; i < records.length; i++) {
        let record = records[i]
        if (record.state == '승인완료') {
          let _domain_count = Object.assign(this.state.domain_count)
          for (const domain of record.competency.split(' ')) {
            _domain_count[domain] = _domain_count[domain] +  1
            this.setState({
              ...this.state,
              domain_count: this.state.domain_count
            })
          }
        }
      }

    });


  }

  batchList = () => {
    return this.state.domains.map( (data) => {
      return (<Tooltip title={data[1]} color={data[2]} key={data[0]}> <Badge size="large" count={this.state.domain_count[data[0]]} showZero>
              <Avatar
                onClick={() => { window.location.href = `/list?tag=${data[0]}` }}
                style={{marginLeft:'30px', backgroundColor:data[2], cursor:'pointer'}}
                shape="square" size={{ xs: 24, sm: 32, md: 40, lg: 64, xl: 80, xxl: 100 }}>{data[0]}</Avatar>
      </Badge>
      </Tooltip>)
    })
  }


  onChange = (info) => {
    if (info.file.status === 'done') {

      axios('/record/my', {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8"
        },
      }).then( res => {
        let data = res.data
        this.setState({
          ...this.state,
          records: data.records,
          username: data.username,
          student_number: data.student_number,
          phone: data.phone,
          managing_professor: data.managing_professor,
          etc: data.etc,
          profile_image: data.profile_image
        })
      });

    }
  }

  removeProfile = () => {
    this.setState({
      ...this.state,
      profile_image: null
    })
  }


  render(){
    let non_accepted_rows = []

    let prevet_rows = []
    let preclinical_rows = []
    let clinical_rows = []


    for (let i=0; i < this.state.records.length; i ++){
      let record = this.state.records[i]
      record.start_at_str = (new Date(record.start_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})
      record.end_at_str = (new Date(record.end_at)).toLocaleDateString('ko-KR', {year:'numeric', month:'long', day:'numeric'})

      if ((record.state != '승인 완료') && (record.state != '승인완료')) {
        non_accepted_rows.push(
                <>
                  <Row className='table-row' key={i}>
                    <Col span={6}><Link to={`/detail/${record.id}`} >{record.start_at_str} - {record.end_at_str}</Link></Col>
                    <Col span={4}>{record.institute}</Col>
                    <Col span={6}>{record.practice}</Col>
                    <Col span={8}><Tag>{record.state}</Tag> {record.deny_comment}</Col>
                  </Row>
                </>
        )
      }


      if (record.state === '승인완료' || record.state === '승인 완료') {
        if (record.curriculum_step == 'prevet') {
          prevet_rows.push(
            <Row className='row-bottom2'>
              <Col span={24}>
                <Row>
                {record.practice}
                </Row>
                <Row>
                {record.institute}
                </Row>
                <Row>
                <Link to={`/detail/${record.id}`} >
                  {record.start_at_str} ~ {record.end_at_str}
                </Link>
                </Row>
              </Col>
            </Row>
          )
        } else if (record.curriculum_step == 'preclinical') {
          preclinical_rows.push(
            <Row className='row-bottom2'>
              <Col span={24}>
                <Row>
                {record.practice}
                </Row>
                <Row>
                {record.institute}
                </Row>
                <Row>
                <Link to={`/detail/${record.id}`} >
                  {record.start_at_str} ~ {record.end_at_str}
                </Link>
                </Row>
              </Col>
            </Row>
          )
        } else if  (record.curriculum_step == 'clinical') {
          clinical_rows.push(
            <Row className='row-bottom2'>
              <Col span={24}>
                <Row>
                {record.practice}
                </Row>
                <Row>
                {record.institute}
                </Row>
                <Row>
                <Link to={`/detail/${record.id}`} >
                  {record.start_at_str} ~ {record.end_at_str}
                </Link>
                </Row>
              </Col>
            </Row>
          )
        }
      }



    }

    prevet_rows = prevet_rows.splice(0,3)
    preclinical_rows = preclinical_rows.splice(0,3)
    clinical_rows = clinical_rows.splice(0,3)




    if (this.state.loading) {
      return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}><Spin size="large" tip="로딩 중..." /></div>
    }

    return (
      <>
        <Col className='wrapper' xs={{span:22, offset:1}}  
          sm={{span:20, offset:2}} 
          md={{span:20, offset:2}} 
          lg={{span:20, offset:2}} 
          xxl={{span:16, offset:4}} 

          style={{marginTop:'40px', }}
          // xl={{span:20, offset:2}} 
          // xxl={{span:20, offset:2}} 
          >
          <Row className='table'>
            <Col span={24}>
            <Row className='label'> 개인정보 </Row>
            <Row className='row1' span={24}>
              <Col flex='auto'  className='col1'>
                <Row className='row'>
                  <Col className='row_title' flex='150px'>
                    이름
                  </Col>
                  <Col className='row_content' flex='auto'>{this.state.username}</Col>
                </Row>
                <Row className='row'>
                  <Col className='row_title' flex='150px'>
                    이메일
                  </Col>
                  <Col className='row_content' flex='auto'>{store.getState().session.email}</Col>
                </Row>
                <Row className='row'>
                  <Col className='row_title' flex='150px'>
                    학번
                  </Col>
                  <Col className='row_content' flex='auto'>{this.state.student_number}
                  </Col>
                </Row>
                <Row className='row'>
                  <Col className='row_title' flex='150px'>
                    지도교수 </Col>
                  <Col className='row_content' flex='auto'>{this.state.managing_professor} 교수</Col>
                </Row>
              </Col>
              <Col flex='147px'>
                <Row className='image_title' >
                  프로필 사진
                </Row>
                <Row style={{height:'auto', width:'100%'}}>
                  { this.state.profile_image ? 
                  <center>
                    <Image
                    className='profile_image'
                    src={resolveFileUrl(this.state.profile_image.url)}
                    onClick={this.removeProfile}
                    />
                  </center>
                  :
                  <Upload
                    className='profile_image'
                    action="/api/record/upload_image_profile"
                    // data={{}}
                    headers= {{
                      'authorization': `Bearer ${store.getState().token}`,
                      // 'content-type': 'multipart/form-data' 
                    }}
                    accept=".JPG,.JPEG,.PNG,.BMP,.jpg,.jpeg,.gif,.png,.bmp,.tiff"
                    listType="picture-card"
                    onChange={this.onChange}
                    // onPreview={this.onPreview}
                    progress={{ strokeWidth: 2, showInfo: true }}
                  >
                    + Upload <br></br>
                    (프로필 사진은 지도교수에게만 공개됩니다)
                  </Upload>
                  }
                </Row>
              </Col>
            </Row>
            </Col>
          </Row>

          <Row className='table'>
            <Col span={24}>
              <Row className='label'> 포트폴리오 작성하기 </Row>
              <Row className='table-content2'> 
                <Col  span={8}>

                  <Link to='/create/실습/'> <Tooltip visible={true} placement='bottom' title={'공공기관, 연구소, 동물병원 등에서의 활동 (4학년 현장실습 포함) 을 기록'} color={'blue'} key={'create'}><Button to='/create/실습/' className='row-top-btn' block >실습</Button></Tooltip></Link>
                  <Typography></Typography>
                </Col>
                <Col  span={8}>
                  <Link to='/create/활동'><Tooltip  visible={true} placement='bottom' title={'봉사, 동아리, 저널클럽, 학생단체, 학생 연구활동 을 기록'} color={'blue'} key={'create'}><Button to='/create/활동/' className='row-top-btn' block >활동</Button></Tooltip></Link>
                </Col>
                <Col  span={8}>
                  <Link to='/create/자기학습'><Tooltip visible={true} placement='bottom' title={'독서, 여행 등 자기학습을 기록'} color={'blue'} key={'create'}><Button to='/create/자기학습/' className='row-top-btn' block >자기학습</Button></Tooltip></Link>
                </Col>
              </Row>
            </Col>
          </Row>
          <Divider/>

          <Row className='table'>
            <Col span={24}>
              <Row className='label'> 졸업 역량 별 포트폴리오 현황 </Row>
              <Row>
                {this.batchList()}
                {/* <Progress format={() => { return (<b>Clinical Reasoning & Decision-making</b>)}}  percent={80}  state="active" strokeColor='blue' />
                <Progress format={() => { return (<b>Individual Animal Care and Management</b>)}}  percent={40}  state="active" strokeColor='sky' />
                <Progress format={() => { return (<b>Animal Population Care and Management</b>)}}  percent={55}  state="active" strokeColor='#005666' />
                <Progress format={() => { return (<b>Public Health</b>)}}  percent={32}  state="active" strokeColor='green' />
                <Progress format={() => { return (<b>Communication</b>)}}  percent={73}  state="active" strokeColor='#5CD453	' />
                <Progress format={() => { return (<b>Collaboration</b>)}}  percent={90}  state="active" strokeColor='#F4D74F' />
                <Progress format={() => { return (<b>Professionalism and Professional Identity</b>)}}  percent={60}  state="active" strokeColor='#FFC681	' />
                <Progress format={() => { return (<b>Financial and Practice Management</b>)}}  percent={30}  state="active" strokeColor='orange' />
                <Progress format={() => { return (<b>Scholarship</b>)}}  percent={20}  state="active" strokeColor='#E00546	' /> */}
              </Row>
            </Col>
          </Row>
          <Divider/>
          <Row className='table'>
            <Col span={24}>
              <Row className='label'> 최근 승인완료 포트폴리오 </Row>
              <Row gutter={12} className='table-content'> 
                <Col  span={8} >
                  <Row className='row-top2 prevet' >예과과정(예1-2)</Row>
                  {prevet_rows.length ? prevet_rows: '승인완료된 포트폴리오가 존재하지 않습니다'}
                </Col>
                <Col  span={8}>
                  <Row className='row-top2 preclinical'>본과 기초과정(본1-2)</Row>
                  {preclinical_rows.length ? preclinical_rows: '승인완료된 포트폴리오가 존재하지 않습니다'}
                </Col>
                <Col  span={8}>
                  <Row className='row-top2 clinical'>본과 임상과정(본3-4)</Row>
                  {clinical_rows.length ? clinical_rows: '승인완료된 포트폴리오가 존재하지 않습니다'}
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className='table'>
            <Col span={24}>
              <Row className='label'> 승인대기 및 반려 포트폴리오 </Row>
              <Row className='table-title'> 
                <Col span={6}>실습 기간</Col>
                <Col span={4}>실습 기관</Col>
                <Col span={6}>실습 내용</Col>
                <Col span={8}>상태 / 반려사유</Col>
              </Row>

              <Row className='table-content'> 
                <Col span={24}>
                  {non_accepted_rows.length ? non_accepted_rows : '대기중인 포트폴리오가 존재하지 않습니다'}
                  {/* <Row className='table-row'>
                    <Col span={4}>2020.12.11. - 2020.12.13.</Col>
                    <Col span={4}>서울대학교 동물병원</Col>
                    <Col span={8}>고양이 암컷 중성화</Col>
                    <Col span={8}>중성화 수술 과정에 대해 보충요망...</Col>
                  </Row>
                  <Row className='table-row'>
                    <Col span={4}>2020.12.11. - 2020.12.13.</Col>
                    <Col span={4}>서울대학교 동물병원</Col>
                    <Col span={8}>고양이 암컷 중성화</Col>
                    <Col span={8}>중성화 수술 과정에 대해 보충요망...</Col>
                  </Row>
                  <Row className='table-row'>
                    <Col span={4}>2020.12.11. - 2020.12.13.</Col>
                    <Col span={4}>서울대학교 동물병원</Col>
                    <Col span={8}>고양이 암컷 중성화</Col>
                    <Col span={8}>중성화 수술 과정에 대해 보충요망...</Col>
                  </Row>
                  <Row className='table-row'>
                    <Col span={4}>2020.12.11. - 2020.12.13.</Col>
                    <Col span={4}>서울대학교 동물병원</Col>
                    <Col span={8}>고양이 암컷 중성화</Col>
                    <Col span={8}>중성화 수술 과정에 대해 보충요망...</Col>
                  </Row> */}
                </Col>

              </Row>
            </Col>
          </Row>



        </Col>
    </>

    )
  }
}